import { Outlet } from 'react-router-dom'
import { ScrollToTop } from '@/components/layout/ScrollToTop'
import { AuthModal } from '@/components/auth/AuthModal'
import { RouteSeoFallback } from '@/components/RouteSeoFallback'

/** Post property flow — no site header/footer */
export function PostPropertyLayout() {
  return (
    <div className="min-h-screen bg-white">
      <RouteSeoFallback />
      <ScrollToTop />
      <AuthModal />
      <Outlet />
    </div>
  )
}
